import React from "react";

import IconButton from "@material-ui/core/IconButton";
import PageviewIcon from "@material-ui/icons/Pageview";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SearchIcon from "@material-ui/icons/Search";
import MoreVertIcon from "@material-ui/icons/MoreVert";

class Action extends React.Component {
  onPreview(row) {}

  render() {
    const { row } = this.props;

    const isDisabled = row.type === "folder";

    return (
      <IconButton
        size="small"
        onClick={(e) => this.onPreview(row)}
        disabled={isDisabled}
      >
        <MoreVertIcon />
      </IconButton>
    );
  }
}

export default Action;
